import React, { useState, useEffect } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Divider } from 'primereact/divider';
import { InputSwitch } from 'primereact/inputswitch';
import { Button } from 'primereact/button';
import FormEditaEmpresa from './FormEditaEmpresa';
import SidebarParametrosIntegracao from './SidebarParametrosIntegracao';



export default function SidebarViewEmpresa(props) {
    const [empresa, setEmpresa] = useState({ ...props.empresa });

    useEffect(() => {
        setEmpresa({ ...props.empresa });
    }, [props.empresa]);

    const customHeader = (
        <div className="flex align-items-center gap-2">           
            <span className="font-bold text-xl">Revenda: {empresa.razaosocial}</span>
        </div>
    );

    return (
        <Sidebar 
        onHide={() => []}
        header={customHeader} visible={props.empresa.idempresa} style={{ minWidth: '40%' }} position="right" {...props}>
            <Divider />
            <div className="flex flex-wrap gap-0 pl-3 pr-4">
                {/* Exibindo informações da empresa */}
                
                <div className="col-12 md:col-6">
                    <span className="" style={{fontSize:'0.7rem'}}>CNPJ/CPF</span>
                    <div className="text-lg">{empresa.cpf_cnpj}</div>
                </div>

                <div className="col-12 md:col-6">
                    <span className="" style={{fontSize:'0.7rem'}}>Isc. Est/RG</span>
                    <div className="text-lg">{empresa.cpf_cnpj}</div>
                </div>

                <div className="col-12 md:col-8">
                    <span className="" style={{fontSize:'0.7rem'}}>R. Social/Nome Completo</span>
                    <div className="text-lg">{empresa.razaosocial}</div>
                </div>

                <div className="col-12 md:col-4">
                    <span className="" style={{fontSize:'0.7rem'}}>Fantasia/Apelido</span>
                    <div className="text-lg">{empresa.nomefantasia}</div>
                </div>

                <div className="col-12 md:col-6">
                    <span className="" style={{fontSize:'0.7rem'}}>Endereço (Logradouro)</span>
                    <div className="text-lg">{empresa.logradouro}</div>
                </div>

                <div className="col-12 md:col-2">
                    <span className="" style={{fontSize:'0.7rem'}}>Nº</span>
                    <div className="text-lg">{empresa.numero}</div>
                </div>

                <div className="col-12 md:col-4">
                    <span className="" style={{fontSize:'0.7rem'}}>Complemento</span>
                    <div className="text-lg">{empresa.complemento}</div>
                </div>

                <div className="col-12 md:col-4">
                    <span className="" style={{fontSize:'0.7rem'}}>CEP</span>
                    <div className="text-lg">{empresa.cep}</div>
                </div>
                <div className="col-12 md:col-8">
                    <span className="" style={{fontSize:'0.7rem'}}>Bairro</span>
                    <div className="text-lg">{empresa.bairro}</div>
                </div>

                <div className="col-12 md:col-8">
                    <span className="" style={{fontSize:'0.7rem'}}>Cidade:</span>
                    <div className="text-lg">{empresa.cidade}</div>
                </div>

                <div className="col-12 md:col-2">
                    <span className="" style={{fontSize:'0.7rem'}}>Estado:</span>
                    <div className="text-lg">{empresa.estado}</div>
                </div>


                <div className="col-12 md:col-6">
                    <span className="" style={{fontSize:'0.7rem'}}>Telefone</span>
                    <div className="text-lg">{empresa.telefonecomercial}</div>
                </div>

                <div className="col-12 md:col-6">
                    <span className="" style={{fontSize:'0.7rem'}}>Celular</span>
                    <div className="text-lg">{empresa.telefonecelular}</div>
                </div>

                <div className="col-12 md:col-12">
                    <span className="" style={{fontSize:'0.7rem'}}>Email</span>
                    <div className="text-lg">{empresa.email}</div>
                </div>


                <br/>
                <Divider/>
                <br/>

                {/* Switch de Ativo */}
                <div className="col-12 md:col-12">
                    <span className="text-lg">Cadastro Ativo</span><br/>
                    <InputSwitch
                        style={{marginTop: '10px'}}
                        checked={empresa.ativo === 't'}
                        onChange={() => {
                            //setEmpresa(prev => ({ ...prev, ativo: prev.ativo === 't' ? 'f' : 't' }))
                        }}
                    />
                </div>

                {/* Switch de Empresa Padrão */}
                <div className="col-12 md:col-12">
                    <span className="text-lg">Empresa Padrão</span><br/>
                    <InputSwitch
                        style={{marginTop: '10px'}}
                        checked={empresa.padrao === 't'}
                        onChange={() => {
                            //setEmpresa(prev => ({ ...prev, padrao: prev.padrao === 't' ? 'f' : 't' }))
                        }
                            
                        }
                    />
                </div>

                {/* Botões abaixo dos switches */}
                <div className="flex justify-content-between gap-3" style={{marginTop : '50px'}}>
                   
                        <FormEditaEmpresa {...props} empresa = {props.empresa}/>
                    
                        <SidebarParametrosIntegracao {...props} empresa = {props.empresa}/>
                 
                    
                </div>
            </div>
        </Sidebar>
    );
}
